<template>
  <svg width="39" height="20" viewBox="0 0 39 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 10.5H36L27 1.5" stroke="currentColor" stroke-width="2" />
  </svg>
</template>

<script>
  export default {
    name: 'IconArrow',
  };
</script>